import { InjectionToken } from '@angular/core';

export interface MenuNavigationTracker {
	trackMenuNavigation(bestemming: string): void;
}

export const MENU_NAVIGATION_TRACKER = new InjectionToken<MenuNavigationTracker>('MENU_NAVIGATION_TRACKER');
